
// 请求接口列表
export default {
  // 获取文档任务(未完成/已完成)数量接口
  getTaskCount: '/taskServerApi/v2/doc/task/status/count',
  // 获取文档任务一览接口
  getTaskList: '/taskServerApi/v2/doc/task/list',
  // 获取文档任务负责人列表
  getTaskUserRela: '/taskServerApi/v2/doc/taskUserRela/select'
}
